

const defineWinnerO = () => {

    return {
        type: "DEFINE_WINNER_O",
        data: [
            { // 1
                "0": [true, "yes"],
                "1": [true, "yes"],
                "2": [true, "yes"],
                "3": [false, "default"],
                "4": [false, "default"],
                "5": [false, "default"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [false, "default"]
            },
            { // 2
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [true, "yes"],
                "4": [true, "yes"],
                "5": [true, "yes"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [false, "default"]
            },
            { // 3
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [false, "default"],
                "4": [false, "default"],
                "5": [false, "default"],
                "6": [true, "yes"],
                "7": [true, "yes"],
                "8": [true, "yes"]
            },
            { // 4
                "0": [true, "yes"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [true, "yes"],
                "4": [false, "default"],
                "5": [false, "default"],
                "6": [true, "yes"],
                "7": [false, "default"],
                "8": [false, "default"]
            },
            { // 5
                "0": [false, "default"],
                "1": [true, "yes"],
                "2": [false, "default"],
                "3": [false, "default"],
                "4": [true, "yes"],
                "5": [false, "default"],
                "6": [false, "default"],
                "7": [true, "yes"],
                "8": [false, "default"]
            },
            { // 6
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [true, "yes"],
                "3": [false, "default"],
                "4": [false, "default"],
                "5": [true, "yes"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [true, "yes"]
            },
            { // 7
                "0": [true, "yes"],
                "1": [false, "default"],
                "2": [false, "default"],
                "3": [false, "default"],
                "4": [true, "yes"],
                "5": [false, "default"],
                "6": [false, "default"],
                "7": [false, "default"],
                "8": [true, "yes"]
            },
            { // 8
                "0": [false, "default"],
                "1": [false, "default"],
                "2": [true, "yes"],
                "3": [false, "default"],
                "4": [true, "yes"],
                "5": [false, "default"],
                "6": [true, "yes"],
                "7": [false, "default"],
                "8": [false, "default"]
            }
        ]

        // {"0": [false, "default"],
        // "1": [false, "default"],
        // "2": [false, "default"],
        // "3": [false, "default"],
        // "4": [false, "default"],
        // "5": [false, "default"],
        // "6": [false, "default"],
        // "7": [false, "default"],
        // "8": [false, "default"]}

    } //end of return
}//end of function


export default defineWinnerO


